import { Spin } from "antd";
import React from "react";

export default function Suspense({ children, fallback }) {
  const fallbackMarkup = fallback ?? <Spin size="mall" />;
  return <React.Suspense fallback={fallbackMarkup}>{children}</React.Suspense>;
}
